import React, { useState, useEffect, use } from "react";
import { Tabs, Card, Spin } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./WhatWeCanOffer.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NoImage from "../../assets/NoImage.png";
import axiosInstance from "../axiosInstance";
import { API } from "../../API";

const { TabPane } = Tabs;

const WhatWeCanOffer = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const maxVisible = 8;
  const [startIndex, setStartIndex] = useState(0);
  const [categories, setCategories] = useState([]);
  const [catLoading, setCatLoading] = useState(true);
  const showArrows = categories.length > maxVisible;
  const visibleCategories = showArrows
    ? categories.slice(startIndex, startIndex + maxVisible)
    : categories;

  const isPrevDisabled = startIndex === 0;
  const isNextDisabled = startIndex >= categories.length - maxVisible;

  useEffect(() => {
    const fetchCategories = async () => {
      setCatLoading(true);
      try {
        const res = await axiosInstance.get(`${API.PRODUCT}/category/list`);
        const items = res.data?.data?.items || [];
        const formatted = items.map((item) => ({
          label: item.categoryName,
          value: item.categoryId,
          categoryIcon: item.categoryIcon,
        }));
        setCategories(formatted);
      } catch (err) {
        console.error("分类获取失败", err);
      } finally {
        setCatLoading(false);
      }
    }
    fetchCategories();
  }, []);

  const handlePrev = () => {
    if (!isPrevDisabled) {
      setStartIndex((prev) => Math.max(0, prev - 1));
    }
  };

  const handleNext = () => {
    if (!isNextDisabled) {
      setStartIndex((prev) =>
        Math.min(categories.length - maxVisible, prev + 1)
      );
    }
  };

  useEffect(() => {
    if (categories.length > 0 && selectedCategory == null) {
      setSelectedCategory(categories[0].label);
    }
  }, [categories]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (!selectedCategory) return;
      try {
        const res = await axiosInstance.get(`${API.PRODUCT}/product/top3`, {
          params: { category: selectedCategory },
        });
        setProducts(res.data.data || []);
      } catch (err) {
        console.error("产品获取失败:", err);
        setProducts([]);
      }
    };
    fetchProducts();
  }, [selectedCategory]);

  if (catLoading || !selectedCategory) return <Spin size="large" />;

  return (
    <div className="offer-section">
      <div className="offer-content">
        <div className="offer-title">
          <h2>What We Can Offer</h2>
        </div>
        <div className="tabs-container">
          {showArrows && (
            <button
              onClick={handlePrev}
              className={`arrow-btn ${isPrevDisabled ? "disabled" : ""}`}
              disabled={isPrevDisabled}
            >
              <span className="arrow-layer arrow-gray"><LeftOutlined /></span>
              <span className="arrow-layer arrow-blue"><LeftOutlined /></span>
            </button>
          )}

          <div className="tabs-wrapper">
            <Tabs
              activeKey={selectedCategory}
              onChange={(key) => setSelectedCategory(key)}
              className="offer-tabs"
              tabBarGutter={30}
              renderTabBar={(props, DefaultTabBar) => (
                <DefaultTabBar {...props} />
              )}
            >
              {visibleCategories.map((cat) => (
                <TabPane
                  key={cat.label}
                  tab={
                    <div className="tab-wrapper">
                      <div className="tab-image">
                        <img src={cat.categoryIcon} alt="icon" />
                      </div>
                      <div className="tab-label">{cat.label}</div>
                    </div>
                  }
                />
              ))}
            </Tabs>
          </div>

          {showArrows && (
            <button
              onClick={handleNext}
              className={`arrow-btn ${isNextDisabled ? "disabled" : ""}`}
              disabled={isNextDisabled}
            >
              <span className="arrow-layer arrow-gray"><RightOutlined /></span>
              <span className="arrow-layer arrow-blue"><RightOutlined /></span>
            </button>
          )}
        </div>

        <div className="tabs-container-mobile">
          <Tabs
            activeKey={selectedCategory}
            onChange={(key) => setSelectedCategory(key)}
            className="offer-tabs-mobile"
            tabBarGutter={30}
            renderTabBar={(props, DefaultTabBar) => (
              <DefaultTabBar {...props} />
            )}
          >
            {categories.map((cat) => (
              <TabPane
                key={cat.label}
                tab={
                  <div className="tab-wrapper">
                    <div className="tab-image">
                      <img src={cat.categoryIcon} alt="icon" />
                    </div>
                    <div className="tab-label">{cat.label}</div>
                  </div>
                }
              />
            ))}
          </Tabs>
        </div>

        <div className="offer-grid">
          {products.slice(0,12).map((item, index) => {
            const imageUrl =
              item.photoUrls && item.photoUrls.length > 0
                ? item.photoUrls[0]
                : NoImage;
            return (
              <div
                key={index}
                className="offer-grid-item"
                onClick={() =>
                  navigate(`/Product/detail/${item.productId}`)
                }
              >
                <Card hoverable className="offer-card">
                  <div className="card-image-wrapper">
                    <img
                      alt={item.productName}
                      src={imageUrl}
                      className="card-image"
                    />
                  </div>
                  <div className="card-title">
                    <h4>{item.productName}</h4>
                  </div>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WhatWeCanOffer;